import * as types from "../../actions/actionTypes";

const sumObj = {
  payment: 0,
  receive: 0,
  remain: 0
};
const initialData = {
  data: {
    data: []
  },
  page_sum: sumObj,
  total_sum: sumObj,
  remain_sum: sumObj,
  use_remain: false,
  chart_data: {}
};
const initialState = {
  loading: false,
  processing: false,
  resetAllStates: false,
  data: initialData,
  error: ""
};

const PettyCashierAccountReview = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_GET_ACCOUNT_REVIEW_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.PETTY_CASHIER_GET_ACCOUNT_REVIEW_SUCCESS:
      return { ...state, data: action.payLoad, loading: false };
    case types.PETTY_CASHIER_GET_ACCOUNT_REVIEW_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_REQUEST:
      return { ...state, processing: true };
    case types.PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_SUCCESS:
      return { ...state, data: action.payLoad, processing: false };
    case types.PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_FAILURE:
      return { ...state, processing: false };

    case types.MULTI_DELETE_TRANSACTIONS_REQUEST:
      return { ...state, processing: true, resetAllStates: false };
    case types.MULTI_DELETE_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        processing: false,
        resetAllStates: true
      };
    case types.MULTI_DELETE_TRANSACTIONS_FAILURE:
      return { ...state, processing: false };

    case types.PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST:
      return { ...state, processing: true };
    case types.PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_SUCCESS:
      return { ...state, processing: false };
    case types.PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_FAILURE:
      return { ...state, processing: false };

    default:
      return state;
  }
};

export default PettyCashierAccountReview;
